// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pairingContainer_B6UPa.pairing_PxtKs {
  position : relative;
  background-color : white;
  min-width : 320px;
  min-height : 400px;
  overflow : unset;
}

.pairingContainerMobile_xmRAn.pairing_PxtKs {
  position : absolute;
  background-color : white;
  min-width : 100%;
  min-height : 100%;
  overflow : unset;
}
`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/views/zoneBeaconPairing/ZoneBeaconPairing.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".pairingContainer.pairing {\n  position : relative;\n  background-color : white;\n  min-width : 320px;\n  min-height : 400px;\n  overflow : unset;\n}\n\n.pairingContainerMobile.pairing {\n  position : absolute;\n  background-color : white;\n  min-width : 100%;\n  min-height : 100%;\n  overflow : unset;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pairingContainer": `pairingContainer_B6UPa`,
	"pairing": `pairing_PxtKs`,
	"pairingContainerMobile": `pairingContainerMobile_xmRAn`
};
export default ___CSS_LOADER_EXPORT___;
